import React from 'react';

import DocumentComponent from '../../../AddOrEditLoan/Sections/Document';

export default function Document({ lenderId }) {
  return <DocumentComponent lenderId={lenderId} />;
}
